import { useConnectModal } from '@rainbow-modules/hooks';
import { Button } from 'react-rainbow-components';
import { ButtonProps } from 'react-rainbow-components/components/Button';
// import Button from 'components/Button';
import SelectPhoneNumberForm from './SelectPhoneNumber';
import useBuyPhone from './hooks/useBuyPhone';
import useBuyPhoneModal from './hooks/useBuyPhoneModal';
import { StyledFormModal } from './styled';

interface BuyPhoneNumberButtonProps extends Omit<ButtonProps, 'onClick'> {
    modalId: string;
}

const BuyPhoneNumberButton = ({ modalId, label = 'Buy New Phone', ...rest }: BuyPhoneNumberButtonProps) => {
    const connectedModalProps = useConnectModal(modalId);
    const [openModal, closeModal] = useBuyPhoneModal(modalId);

    const { mutate: buyPhone } = useBuyPhone();

    const handleBuyNewPhone = () => openModal({
        title: 'Buy a new phone number',
        submitButtonLabel: 'Add',
        onSubmit: async (submittedValues: Record<string, string>) => {
            buyPhone({
                body: {
                    number: submittedValues.phoneNumber,
                },
            });
            closeModal();
        },
    });

    return (
        <>
            <Button
                {...rest}
                label={label}
                onClick={handleBuyNewPhone}
            />
            <StyledFormModal
                {...connectedModalProps}
                size="large"
                borderRadius="semi-square"
                fields={SelectPhoneNumberForm}
            />
        </>
    );
};

export default BuyPhoneNumberButton;
